import React from 'react';

export default function Chat() {
  return (
    <svg width="22" height="14" viewBox="0 0 22 14">
      <path d="M6.25,2.27a1.23,1.23,0,0,1,0,1.81l-3,2.82,3,2.82a1.24,1.24,0,0,1,0,1.82,1.4,1.4,0,0,1-1.91,0l-4-3.76A1.22,1.22,0,0,1,0,6.9,1.26,1.26,0,0,1,.38,6l4-3.75A1.38,1.38,0,0,1,6.25,2.27Zm9.5,0a1.38,1.38,0,0,1,1.91,0l4,3.75A1.26,1.26,0,0,1,22,6.9a1.22,1.22,0,0,1-.38.88l-4,3.76a1.4,1.4,0,0,1-1.91,0,1.24,1.24,0,0,1,0-1.82l3-2.82-3-2.82A1.23,1.23,0,0,1,15.75,2.27ZM9.15,14a1.44,1.44,0,0,1-1.09-1.74L11,1.08a1.52,1.52,0,0,1,1.83-1,1.44,1.44,0,0,1,1.09,1.74L11,12.92A1.52,1.52,0,0,1,9.15,14Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Code/index.js